import { render, staticRenderFns } from "./AffirmationAddModal.vue?vue&type=template&id=2966c282"
import script from "./AffirmationAddModal.vue?vue&type=script&lang=js"
export * from "./AffirmationAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports